import Text from "./text";
import Select from "./select";
import Switch from "./switch";
import Checkbox from "./checkbox";
import MultiSelect from "./multiselect";
import ProductMultiSelect from "./product-multiselect";
import TextArea from "./textarea";
import Slider from "./slider";
import Upload from "./upload";
import MultipleUpload from "./multipe-upload";
import Editor from "./editor";
import SimpleSelect from "./simple-select";
import Radio from "./radio";

export {
	Text,
	Upload,
	Switch,
	Select,
	Checkbox,
	MultiSelect,
	ProductMultiSelect,
	TextArea,
	Slider,
	Editor,
	MultipleUpload,
	SimpleSelect,
	Radio,
};
